'use client';

import {SiteSettingsContext} from '@/context/SiteSettingsContext';
import {SiteSettingFieldsFragment} from '@common/hygraph-schema';

interface SiteSettingsProviderProps {
	children: React.ReactNode;
	siteSettings: SiteSettingFieldsFragment;
}

export function SiteSettingsProvider({children, siteSettings}: SiteSettingsProviderProps) {
	const cmsRedeemDisabled =
		siteSettings.redeemDisabled === true && siteSettings.siteBannerEnabled === true;
	return (
		<SiteSettingsContext.Provider value={{...siteSettings, cmsRedeemDisabled}}>
			{children}
		</SiteSettingsContext.Provider>
	);
}
